module.exports = __webpack_public_path__ + "images/assets/420e1b20aa1060fe905888befebb6f93.svg";